import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import {useTranslation} from "react-i18next";

export default function ConfirmRewriteFiles({handleDisagree, handleAgree}) {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    return (
        <div>
            <Dialog
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                open={true}
                onClose={handleDisagree}
            >
                <DialogTitle>{t('duplicate_doc_detected')}</DialogTitle>
                <DialogContent>
                    <Alert severity="error">
                        <Typography variant="body1">
                            {
                                currentLang === 'en'
                                    ? 'You have recently already submitted consent/refusal documents. They have not yet been reviewed. ' +
                                    'If you submit new documents, the previous ones will be replaced. ' +
                                    'Are you sure you want to submit new documents?'
                                    : 'Вы недавно уже отправляли документы о согласии/отказе на проверку их еще не проверили. В случае ' +
                                    'новой отправки старые проверяемые документы заменятся ' +
                                    'на новые. Вы действительно хотите отправить новые документы?'
                            }
                        </Typography>
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDisagree} color="primary">
                        {t('no')}
                    </Button>
                    <Button onClick={handleAgree} color="primary" autoFocus>
                        {t('yes')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}